import React, { useEffect, useState } from 'react';
import { matchRoutes } from 'react-router-config';
import { useSelector, useDispatch } from 'react-redux';
import {  Switch, useLocation, useParams } from 'react-router-dom';
import { Routes as RoutesList } from 'components/Route';
import _ from 'lodash';
import { 
  makeStyles, 
  createStyles, 
  Theme
} from '@material-ui/core/styles';
import { 
  useMediaQuery,
  Box,
 } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import {injectIntl} from 'react-intl';
import LoadableComponent from 'components/LoadableComponent';
import BasicConfig from 'config/basic/config.json';
import LayoutConfig from './config.json';
import LayoutHelmetHead from 'components/LayoutHelmetHead';


const SkeletonLoading = () => {
  return (
    <>
      <Box>
        <Box px={3} pb={3} bgcolor="#fff" >
          <Skeleton height={30} />
        </Box>
      </Box>
      <Box px={3} py={4}>
        <Box p={3} bgcolor="#fff">
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} width="60%" />
        </Box>
        <Box mt={3} p={3} bgcolor="#fff">
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} width="60%" />
        </Box>
      </Box>
    </>
  )
}

const BasicContent = injectIntl((props:any) => {
  const { intl, RouteComponents } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const sharedData = useSelector((state:any) => state.global.sharedData);
  const moduleAcl = useSelector((state:any) => state.global.moduleAcl);
  const userInfo = sharedData.user.data;

  return (
    <>
      <LayoutHelmetHead {...props} fontFamilys={LayoutConfig.fontFamily}/>
      <main
      >
        <Switch>
          {
             Object.keys(RouteComponents).length > 0 && <RoutesList rootPath={props.rootPath} userInfo={userInfo} moduleAcl={moduleAcl} routeComponents={RouteComponents} routes={props.routes} langRoutes={props.langRoutes}  redirect={props.redirect || {}}/>
          }
        </Switch>
      </main>
    </>
  )
})


const BasicLayout = (props:any) => {
  const modulesPlugin = props.modulesPlugin || {};
  const PageLoadings = Object.keys(modulesPlugin).map((moduleName) => modulesPlugin[moduleName].default.components.PageLoading).filter((component) => component)
 
  const PageLoading = () => React.createElement(PageLoadings[0]);

  return (
    <LoadableComponent SkeletonLoading={PageLoadings.length && PageLoading || SkeletonLoading} {...props}>
      <BasicContent {...props}/>
    </LoadableComponent>
  )
}

export default BasicLayout;